module.exports = __webpack_public_path__ + "img/td.024e1d49.svg";